import { render, staticRenderFns } from "./addAmount.vue?vue&type=template&id=2e5f473a&scoped=true&"
import script from "./addAmount.vue?vue&type=script&lang=ts&"
export * from "./addAmount.vue?vue&type=script&lang=ts&"
import style0 from "./addAmount.vue?vue&type=style&index=0&id=2e5f473a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5f473a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
